import React from 'react';
import { SelectionPanelGroup, SelectionPanelGroupBaseProps, SelectionPanelProps } from './SelectionPanelGroup';
import { SelectionPanelGroupSelectionType } from './common/SelectionPanelGroupSelectionType';

/**
 * All of SelectionPanelGroup's look-and-layout props; this component supplies the Yes/No items and the selection
 * itself, bound to a boolean value instead of selected ids.
 */
export interface YesNoSelectionPanelGroupProps extends SelectionPanelGroupBaseProps {
    /** true = Yes, false = No, undefined = nothing selected. */
    value: boolean | undefined;
    onChange: (value: boolean | undefined) => void;
}

/** A single-select SelectionPanelGroup with "Yes" and "No" options, bound to a boolean | undefined value. */
export const YesNoSelectionPanelGroup: React.FC<YesNoSelectionPanelGroupProps> = ({ id, value, onChange, ...groupProps }) => {
    // Each panel's id is also its DOM id, so prefix with the group id to keep it unique on the page.
    const yesId = `${id}_yes`;
    const noId = `${id}_no`;

    const items: SelectionPanelProps[] = [
        { id: yesId, children: 'Yes' },
        { id: noId, children: 'No' },
    ];

    const selectedPanels = value === true ? [yesId] : value === false ? [noId] : [];

    const handleSelectionChange = (selections: string[]) => {
        const selectedId = selections[0];
        onChange(selectedId === yesId ? true : selectedId === noId ? false : undefined);
    };

    return (
        <SelectionPanelGroup
            {...groupProps}
            id={id}
            items={items}
            selectedPanels={selectedPanels}
            set_selectedPanels={handleSelectionChange}
            selectionType={SelectionPanelGroupSelectionType.Single}
        />
    );
};
